const reservationFormConfig = window.reservationFormConfig;

const validStatus = (status) => {
  return status === "premarketing" || status === "onsale";
};

const validAvailability = (availability) => {
  return availability === "free" || availability === "reserved";
};

const getContent = (status, availability, contentType) => {
  if (validStatus(status) && validAvailability(availability)) {
    return reservationFormConfig[status][availability][contentType];
  }
  if (!validStatus(status)) {
    throw new Error("Invalid status!");
  }
  if (!validAvailability(availability)) {
    throw new Error("Invalid availability!");
  }
};

const getHeading = (status, availability) => {
  return getContent(status, availability, "heading");
};

const getFooter = (status, availability) => {
  return getContent(status, availability, "footer");
};

export default { getHeading, getFooter };
